import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { CartProvider } from "../context/CartContext";
import { GlobalProvider } from "../context/GlobalContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const RootProvider = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    <GlobalProvider>
      <CartProvider>{children}</CartProvider>
    </GlobalProvider>
  </QueryClientProvider>
);

export default RootProvider;
